module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/alida-7a100ca69e31367239f04e013fc24465.jpg";